import React from 'react';
import classNames from 'classnames';
import { PetAvatar } from 'types/pet';
import { PetAvatarButton } from './pet-avatar-button';
import { AvatarSizes, AvatarButtonDisplayFormat } from './AvatarEnums';
import './avatar-layout.scss';

export const AvatarLayout = ({
  onSetNewAvatar,
  items,
  size = AvatarSizes.MEDIUM,
  selected,
  type,
}: {
  onSetNewAvatar: (key: string, avatarId: string) => void;
  items: Array<PetAvatar>;
  size?: AvatarSizes;
  selected: string;
  type: AvatarButtonDisplayFormat;
}) => (
  <ul className={`pet-avatar-layout pet-avatar-layout--${size}`}>
    {items.map((item: PetAvatar) => (
      <li
        key={item.imageUrl}
        className={classNames(
          `pet-avatar-layout__column pet-avatar-layout__column--${size}`,
          type === AvatarButtonDisplayFormat.TILE
            ? 'pet-avatar-layout__tile'
            : 'pet-avatar-layout__circle',
        )}
      >
        <PetAvatarButton
          image={item.imageUrl}
          size={size}
          click={() => onSetNewAvatar(item.imageUrl, item.id)}
          isSelected={item.imageUrl === selected || item.id === selected}
        >
          {item.caption}
        </PetAvatarButton>
      </li>
    ))}
  </ul>
);
